<app-expandable-table [info]="tableData" (toggleExpansion)="toggleState($event)" [pageRefreshed]="pageRefreshed"></app-expandable-table>
